import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { combineLatest, Subscription } from 'rxjs';
import { PlanningDay } from 'src/app/classes/planning-day.class';
import { PlanningFixed } from 'src/app/classes/planningfixed.class';
import { PlanningFixedService } from 'src/app/services/planning/planning-fixed.service';
import { Utils } from 'src/app/utils.class';

@Component({
    selector: 'app-set-planning-fixed-dialog',
    templateUrl: './set-planning-fixed-dialog.component.html',
    styleUrls: ['./set-planning-fixed-dialog.component.scss'],
    standalone: false,
})
export class SetPlanningFixedDialogComponent implements OnInit, OnDestroy {
    fixedDate: Date;
    mayFixPlanning = false;
    mayFixDay = false;
    private subscriptions = new Subscription();

    constructor(
        @Inject(MAT_DIALOG_DATA) public day: PlanningDay,
        public dialogRef: MatDialogRef<SetPlanningFixedDialogComponent>,
        private planningFixedService: PlanningFixedService
    ) {}

    ngOnInit() {
        this.subscriptions.add(
            combineLatest([
                this.planningFixedService.getLatestFixedUntilItem(),
                this.planningFixedService.getFixedDays(),
            ]).subscribe(([fixed, fixedDays]) => {
                this.fixedDate = fixed?.fixeduntil ? new Date(fixed.fixeduntil) : new Date(0);
                this.mayFixPlanning = this.fixedDate < this.day.date;
                this.mayFixDay = !this.isFixedSpecificDay(this.day.date, fixedDays || []);
            })
        );
    }

    fixPlanning() {
        const fixedDate = Utils.setTime(new Date(this.day.date), 23, 59);
        this.planningFixedService.setFixed(fixedDate);
        this.dialogRef.close();
    }

    fixSingleDay() {
        const fixedDate = Utils.formatDate(this.day.date);
        this.planningFixedService.setFixedDay(fixedDate);
        this.dialogRef.close();
    }

    onNoClick() {
        this.dialogRef.close();
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    private isFixedSpecificDay(date: Date, fixedDays: PlanningFixed[]): boolean {
        const dayKey = this.dayKey(date);
        return fixedDays.some(fixedDay => this.dayKeyFromInput(fixedDay.fixed_date) === dayKey);
    }

    private dayKey(date: Date): string {
        return Utils.formatDate(date);
    }

    private dayKeyFromInput(value: Date | string): string {
        if (typeof value === 'string') {
            return value.substring(0, 10);
        }
        return this.dayKey(value);
    }
}
